import api from './api';

export type SelectionStatus = 'all' | 'selected' | 'pending';

export interface HistorySuggestion {
  id: string;
  description: string | null;
  group: string | null;
  parentGroup: string | null;
  tags: string[];
  solution: string | null;
  confidence: number | null;
  rank: number | null;
}

export interface SelectionRecord {
  id: string;
  description: string;
  generatedAt: string | null;
  selectedAt: string | null;
  status: 'selected' | 'pending';
  suggestionCount: number;
  responseStatus: 'available' | 'empty' | 'unavailable';
  suggestions: (HistorySuggestion & { isSelected: boolean })[];
  selected: HistorySuggestion | null;
}

export interface SelectionHistoryResponse {
  success: boolean;
  data: SelectionRecord[];
  pagination: { currentPage: number; pageSize: number; hasNextPage: boolean; hasPrevPage: boolean };
}

export async function getSelectionHistory(params: {
  page: number; limit: number; status: SelectionStatus; search: string; date: string;
}, signal: AbortSignal): Promise<SelectionHistoryResponse> {
  const { date, ...query } = params;
  let range = {};
  if (date) {
    const from = new Date(date + 'T00:00:00');
    const to = new Date(from);
    to.setDate(to.getDate() + 1);
    range = { from: from.toISOString(), to: to.toISOString() };
  }
  const response = await api.get<SelectionHistoryResponse>('/api/hybrid/selections', {
    params: { ...query, ...range }, signal, timeout: 20000
  });
  if (!response.data.success) throw new Error('Kayıtlar yüklenemedi.');
  return response.data;
}
